import { HOUSE_ID, TOKEN, USER_INFO } from '@root/constant';

let cacheCurrentAuth: any = {};

const getCurrentAuth = () => {
  try {
    if (cacheCurrentAuth.id) {
      return cacheCurrentAuth;
    }
    const localCurrentAuth = window.localStorage.getItem(USER_INFO);
    if (localCurrentAuth) {
      cacheCurrentAuth = JSON.parse(localCurrentAuth);
    }
    return cacheCurrentAuth;
  } catch {
    return cacheCurrentAuth;
  }
};

let cacheAccessToken: string;

const getCurrentToken = () => {
  if (cacheAccessToken) {
    return cacheAccessToken;
  }
  cacheAccessToken = window.localStorage.getItem(TOKEN) || '';
  return cacheAccessToken;
};

let cacheHouseId: string;

const getCurrentHouseId = () => {
  if (cacheHouseId) {
    return cacheHouseId;
  }
  cacheHouseId = window.localStorage.getItem(HOUSE_ID) || '';
  return cacheHouseId;
};

export { getCurrentAuth, getCurrentToken, getCurrentHouseId };
